import React from "react"

import Link from 'components/common/link/Link'
import Button from 'components/forms/button/Button'

import * as st from './MobileMenu.styled.js'

const MobileMenu = ({
  isOpen,
  onCloseMobileMenu,
}) => (
  <st.Wrap isOpen={isOpen} >
    <st.Section>
      <st.Caption>General</st.Caption>
      <st.MenuItem onClick={onCloseMobileMenu}>
        <Link
          type="link"
          view="secondary"
          size={300}
          href="/pricing"
        >
          Pricing
        </Link>
      </st.MenuItem>
      <st.MenuItem onClick={onCloseMobileMenu}>
        <Link
          type="a"
          view="secondary"
          size={300}
          href="/changelog/"
          onClick={onCloseMobileMenu}
        >
          Product updates
        </Link>
      </st.MenuItem>
    </st.Section>
    <st.Footer>
      <Button
        type="a"
        view="secondary"
        size={600}
        href="https://scope.ws/sign-in"
        onClick={onCloseMobileMenu}
      >
        Sign In
      </Button>
      <Button
        type="a"
        view="primary"
        size={600}
        href="https://cal.com/scope/demo"
        data-event="book-demo"
        onClick={onCloseMobileMenu}
      >
        Book a Demo
      </Button>
    </st.Footer>
  </st.Wrap>
)

export default MobileMenu
